import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.history.query.gql"
import type {
  TenantPrivacyHistoryQuery,
  TenantPrivacyHistoryQueryVariables,
} from "@/v2-backoffice-client/tenant/privacy/__types__/tenant.privacy.history.query"

type Options = QueryHookOptions<
  TenantPrivacyHistoryQuery,
  TenantPrivacyHistoryQueryVariables
>

export function useTenantPrivacyHistoryQuery(options?: Options) {
  return useQuery<
    TenantPrivacyHistoryQuery,
    TenantPrivacyHistoryQueryVariables
  >(query, options)
}
